// src/utils/formatNames.js
// This file will contain utility functions for formatting agent and wallet names

/**
 * Format agent name to remove email/username prefixes
 * @param {string} name - The agent name to format
 * @returns {string} - The formatted agent name
 */
export const formatAgentName = (name) => {
  if (!name) return 'Unnamed Agent';
  
  // Check if the name contains an email pattern or username
  if (name.includes('@') || name.includes("'s")) {
    // Extract just the "Agent X" part
    const matches = name.match(/(?:.*?'s\s)?(Agent\s+\d+)/i);
    if (matches && matches[1]) {
      return matches[1];
    }
    // Fallback: remove everything before "Agent"
    return name.replace(/^.*?(?=(Agent|$))/, '').trim() || 'Agent';
  }
  
  // If it just has "Agent X" format already, return as is
  if (name.match(/^Agent\s+\d+$/i)) {
    return name;
  }
  
  return name;
};

/**
 * Format wallet name to remove email/username prefixes
 * @param {string} name - The wallet name to format
 * @returns {string} - The formatted wallet name
 */
export const formatWalletName = (name) => {
  if (!name) return 'Unnamed Wallet';
  
  // Check if the name contains an email pattern or username
  if (name.includes('@') || name.includes("'s")) {
    // Extract just the "Agent X Wallet" part
    const matches = name.match(/(?:.*?'s\s)?(Agent\s+\d+\s+Wallet)/i);
    if (matches && matches[1]) {
      return matches[1];
    }
    // Fallback: remove everything before "Wallet"
    return name.replace(/^.*?(?=(Wallet|$))/, '').trim() || 'Wallet';
  }
  
  return name;
};

/**
 * Format wallet address to show first 4 and last 4 characters
 * @param {string} address - The wallet address to format
 * @returns {string} - The formatted wallet address
 */
export const formatAddress = (address) => {
  if (!address || address.length < 10) return address || '';
  return `${address.substring(0, 4)}...${address.substring(address.length - 4)}`;
};

// Update the export to include the new function
export default {
  formatAgentName,
  formatWalletName,
  formatAddress
};